var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emitter"},_vm._l((_vm.particles),function(p){return _c('div',{key:p.id,staticClass:"particle",style:({
      transform: ("translate(" + (p.x) + "px, " + (p.y) + "px) rotate(" + (p.a) + "rad)"),
      opacity: ("" + (p.l)),
    })},[_vm._v(" "+_vm._s(p.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }